import PolicyLayout from './PolicyLayout';
import { LEGAL_UPDATED, SITE_DOMAIN, SITE_NAME } from '../constants/site';

export default function TermsOfService() {
  return (
    <PolicyLayout
      title="Terms of Service"
      updated={LEGAL_UPDATED}
      intro={`These Terms of Service govern your use of ${SITE_DOMAIN} (${SITE_NAME}). By accessing this website or purchasing design software or digital marketing software, you agree to these terms.`}
    >
      <h2>Who we are</h2>
      <p>
        {SITE_NAME} is an independent online store for design software and
        digital marketing tools. We provide licensing, download access, and
        customer support for freelancers, studios, and businesses.
      </p>

      <h2>Eligibility</h2>
      <p>
        You must be at least 18 years old (or the age of majority in your
        jurisdiction) and able to form a binding contract to purchase from us.
      </p>

      <h2>Accounts and orders</h2>
      <p>
        You agree to provide accurate contact and billing information. We may
        refuse or cancel an order if we suspect fraud, pricing error, or
        violation of these terms.
      </p>

      <h2>Licences</h2>
      <p>
        Software is licensed, not sold as unrestricted ownership. Seat counts,
        commercial use rights, and update windows are stated at checkout. You may
        not resell, rent, or redistribute licences except as expressly allowed by
        the licence terms for that category.
      </p>

      <h2>Delivery</h2>
      <p>
        After successful payment, download links and activation instructions are
        sent to the email address you provide. You are responsible for keeping
        that address accessible.
      </p>

      <h2>Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Attempt to reverse engineer or crack licensed software.</li>
        <li>Abuse support channels or submit fraudulent refund claims.</li>
        <li>
          Use our site or tools in ways that violate applicable law or third-party
          rights.
        </li>
      </ul>

      <h2>Pricing</h2>
      <p>
        Prices are shown in the currency indicated at checkout and may change
        without notice. Taxes may apply based on your location. The price
        confirmed at checkout is the price for that order.
      </p>

      <h2>Intellectual property</h2>
      <p>
        Website content, branding, and copy belonging to {SITE_NAME} remain our
        property. Third-party trademarks, if any appear elsewhere, belong to
        their owners.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, {SITE_NAME} is not liable for
        indirect, incidental, or consequential damages arising from use of this
        website or purchased software. Our aggregate liability for any claim
        related to an order is limited to the amount you paid for that order.
      </p>

      <h2>Governing law</h2>
      <p>
        These terms are governed by applicable law without regard to
        conflict-of-law principles.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these Terms of Service. Continued use of the site after
        changes constitutes acceptance of the revised terms.
      </p>
    </PolicyLayout>
  );
}
